<template>
  <div class="sdk">
    <sdk nameEn="android-bluetooth-sdk"></sdk>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import sdk from '@/components/common/sdk.vue';
export default {
  inject: ['reload'],
  metaInfo: {
    title: 'Android北斗蓝牙SDK',
    meta: [
      {
        name: 'keywords',
        content: '北斗蓝牙sdk,北斗追踪sdk,北斗安卓sdk,发送短报文sdk',
      },
      {
        name: 'description',
        content:
          '北斗蓝牙管理模块sdk、北斗重连sdk、短报文接收数据sdk、北斗盒子信息sdk、短报文通信申请发送短报文sdk、北斗SOS模块sdk、北斗极限追踪模块sdk，北斗一键报平安OK键模块sdk。',
      },
    ],
  },
  components: {
    sdk,
  },
  methods: {
    ...mapActions(['setBg']),
  },
  watch: {
    $route: function (newVal, oldVal) {
      // 路由变化展示新文件
      console.log({ newVal, oldVal });
      if (newVal.name !== oldVal.name) {
        this.reload();
      }
    },
  },
  created() {
    this.setBg(this.$route.meta.showBg);
  },
};
</script>

<style lang="scss" scoped>
</style>